import { Inquiry } from '@/types/inquiry';
import BaseStore from './BaseStore';
import { InquiryApi } from '@/apis';
import RootStore from '.';
import { GetInquiriesRequest, GetInquiriesResponse, PostInquiryRequest, PutInquiryRequest } from '@/types/http-payload/inquiry';
import { TableState } from '@tanstack/react-table';
import { ResponseData } from '@/types/http';
import { flow, makeObservable, observable } from 'mobx';

export default class InquiryStore extends BaseStore {
    inquiries: Inquiry[] = [];
    api: InquiryApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            inquiries: observable,
            getInquiries: flow.bound,
            createInquiry: flow.bound,
            getEmails: flow.bound,
            getInquiryId: flow.bound,
            updateInquiry: flow.bound,
            deleteInquiry: flow.bound
        });
        this.api = new InquiryApi();
    }

    *createInquiry(payload: PostInquiryRequest) {
        try {
            const res: ResponseData<Inquiry> = yield this.rootStore.apiStore.call(this.api, this.api.createInquiry, payload);
            if (res) {
                return res.data;
            }
        } catch (error) {
        }
    }

    *getInquiries(request: GetInquiriesRequest, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...request };
            const res: ResponseData<GetInquiriesResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getInquiries, payload);
            if (res.ok) {
                this.inquiries = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecord = res.data.paginate.totalRecord;
            }
        } catch (error) {
        }
    }

    *getEmails() {
        try {
            const res: ResponseData<GetInquiriesResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getInquiries, { page: -1 });
            if (res.ok) {
                const emails: string[] = res.data.elements.map((item) => {
                    return item.email;
                })
                    .filter((item): item is string => typeof item === 'string' && item !== '');
                return [...new Set(emails)];
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    *getInquiryId(id: string) {
        try {
            const res: ResponseData<Inquiry> = yield this.rootStore.apiStore.call(this.api, this.api.getInquiry, id);
            if (res.ok) {
                return res.data;
            }
            return null;
        } catch (error) {
        }
    }

    *updateInquiry(id: string, payload: PutInquiryRequest) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.updateInquiry, { id, payload });
            if (res.ok) {
                return res;
            }
        } catch (error) {
        }
    }

    *deleteInquiry(id: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.deleteInquiry, id);
            if (res.ok) {
                return res;
            }
        } catch (error) {
        }
    }
}
